module.exports = __webpack_public_path__ + "static/media/Groups.e0b46c91.svg";